import { Badge } from '@/components/ui/badge';
import { useDictionary } from '@/lib/context/locale-provider';
import { Languages } from '@/lib/dictionaries';
import { useGetCartCountingQuery } from '@/slice/cartApi';
import { ShoppingCart } from 'lucide-react';
import Link from 'next/link';
import React from 'react';
import '@/app/input.css';

function HeaderShopCart({
  className,
  useIcon,
  lang,
}: {
  className: string;
  useIcon: boolean;
  lang: Languages;
}) {
  const dict = useDictionary();
  const { data } = useGetCartCountingQuery();

  return (
    <div className="relative inline-block pl-5 xl:pl-7">
      <Link href={`/${lang}/cart`} className={className}>
        {useIcon ? (
          <ShoppingCart width={25} height={25} />
        ) : (
          dict!.shop.shippingCart
        )}
      </Link>
      {data && (
        <Badge
          className={`${useIcon ? 'absolute top-2 left-5' : 'absolute -top-2 -right-1'} bg-[#FF6161] hover:bg-[#FF6161] px-[3px] h-[11px] min-x-[11px]`}
        >
          {data.counting}
        </Badge>
      )}
    </div>
  );
}

export default HeaderShopCart;
